import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import settlementSales from "../../../containers/modules/mutation/settlement-sales";

export default function SettlementSalesRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="/settlement-sales"
      index
      element={
        <AccessControl
          name={"Settlement Sales List"}
          auth={authUser}
          component={settlementSales}
        />
      }
    />
  );
}
